
export default function About() {
  const features = [
    { icon: 'ri-medal-line', label: 'Certified Experts' },
    { icon: 'ri-leaf-line', label: 'Organic Methods' },
    { icon: 'ri-plant-line', label: 'Local Plants' },
    { icon: 'ri-calendar-line', label: 'Year-Round Service' }
  ];

  return (
    <section id="about" className="py-24 bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-gray-400 text-xs uppercase tracking-widest mb-6 font-light">
            ABOUT US
          </p>
          <h2 className="text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-20">
            Growing Beautiful<br />
            Gardens With<br />
            Passion & Care
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-[#2a2a2a] rounded-2xl p-6 hover:bg-[#333333] transition-colors cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <p className="text-white text-sm font-medium">
                {feature.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
